module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2-774ffb25fd4c9ee094fc268e12dafc1a.jpg";